import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CartProvider } from "@/context/CartContext";
import { Toaster } from "@/components/ui/sonner";
import { LAUNCH_DATE } from "@/lib/api";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import ComingSoon from "@/pages/ComingSoon";

// Owner preview bypass: visit /?preview=1 to unlock the full site before launch (/?preview=0 to relock)
const params = new URLSearchParams(window.location.search);
if (params.get("preview") === "1") localStorage.setItem("stb_preview", "1");
if (params.get("preview") === "0") localStorage.removeItem("stb_preview");

const isPreview = localStorage.getItem("stb_preview") === "1";
const isLive = Date.now() >= new Date(LAUNCH_DATE).getTime();
const showSite = isLive || isPreview;

function App() {
  return (
    <CartProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={showSite ? <Home /> : <ComingSoon />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </CartProvider>
  );
}

export default App;
